import { getToken } from '../Utils/Common';

let url = process.env.REACT_APP_BACKEND_API_URI

export function updatePositionCategory(lvID, rowId, category) {
    let updateData = {
        lv_id: lvID,
        row_id: rowId,
        update: { category: category },
        collection: 'lv'
    };

    return fetch(`${process.env.REACT_APP_BASE_URI}/api/parser/update`, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + getToken()
        },
        body: JSON.stringify(updateData)
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export function getPositionCategory(lvID) {
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/parser/v1/resources/displaylv/` + lvID, {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + getToken()
        }
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function getMatchedPosition(hash) {

    return fetch(`${url}parser/read_position_matches`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"hash": hash, "token": getToken()})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}

export async function updatePreference(lvID, rowID, hash, pText) {

    return fetch(`${url}parser/update_position_preference`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"hash": hash, "lv_id":lvID, "rowId":rowID, "pText":pText, "token": getToken()})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}

export function readPreference(hash) {

    return fetch(`${url}parser/read_position_preference`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({"hash": hash, "token": getToken()})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}
